"use client"
/* */
const ListFilter = (ignoredProps) => null;
const TypedListFilter = () => ListFilter;

export { ListFilter, TypedListFilter };
//# sourceMappingURL=ListFilter.mjs.map
